import React, { useContext } from 'react';
import { Navigate } from 'react-router';

import { UserContext } from './context/UserContext';

const AdminGuard = ({ children }) => {
  const { user } = useContext(UserContext);

  if (!user) return null;

  if (!user?.permissions?.admin && !user?.permissions?.superadmin) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminGuard;
